import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableHeadComponent } from "../../common/TableHead";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { handleSendImmixTest } from "./EditCameraUtils/handleSendImmixTest";
import { handleSendDiceTest } from "./EditCameraUtils/handleSendDiceTest";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import {
  Switch,
  Tooltip,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Input,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { createDots } from "../../common/createDots";
import { useAppStore } from "../../../appStore";
import React from "react";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";
import {
  PatriotDeliverySummary,
  usePatriotIgnoreZonesOnAlertPage,
} from "../../common/PatriotDrawIgnoreZonesGate";
import {
  PATRIOT_DELIVERY_LABEL,
  patriotDeliveryDisplayText,
} from "../../common/PatriotDeliveryChoice";
import SelectedStreamDropDown from "./SelectedStreamDropDown";

export const AlertSettingsTab = ({
  immixAlerts,
  setAddImmixAlertDialogOpen,
  setSendingImmixTest,
  setImmixTestSuccessDialogOpen,
  setImmixTestFailDialogOpen,
  setDeleteImmixAlertDialogOpen,
  diceAlerts,
  setAddDiceAlertDialogOpen,
  setSendingDiceTest,
  setDiceTestSuccessDialogOpen,
  setDiceTestFailDialogOpen,
  setDeleteDiceAlertDialogOpen,
  sureviewAlerts,
  setAddSureviewAlertDialogOpen,
  setAddStreamWebhookDialogOpen,
  setEditStreamWebhookDialogOpen,
  sentinelAlerts,
  setAddSentinelAlertDialogOpen,
  boldAlerts,
  setAddBoldAlertDialogOpen,
  patriotAlerts,
  setAddPatriotAlertDialogOpen,
  softguardAlerts,
  setAddSoftguardAlertDialogOpen,
  immixAlertsOnCamera,
  diceAlertsOnCamera,
  sureViewAlertsOnCamera,
  siteInfo,
  webhooksAlertsOnCamera,
  sentinelAlertsOnCamera,
  boldAlertsOnCamera,
  patriotAlertsOnCamera,
  softguardAlertsOnCamera,
  evalinkAlertsOnCamera,
  navigate,
}: {
  immixAlerts?: any;
  setAddImmixAlertDialogOpen?: any;
  setSendingImmixTest?: any;
  setImmixTestSuccessDialogOpen?: any;
  setImmixTestFailDialogOpen?: any;
  setDeleteImmixAlertDialogOpen?: any;
  diceAlerts?: any;
  setAddDiceAlertDialogOpen?: any;
  setSendingDiceTest?: any;
  setDiceTestSuccessDialogOpen?: any;
  setDiceTestFailDialogOpen?: any;
  setDeleteDiceAlertDialogOpen?: any;
  sureviewAlerts: any;
  setAddSureviewAlertDialogOpen: any;
  setAddStreamWebhookDialogOpen: any;
  setEditStreamWebhookDialogOpen: any;
  sentinelAlerts: any;
  setAddSentinelAlertDialogOpen: any;
  boldAlerts: any;
  setAddBoldAlertDialogOpen: any;
  patriotAlerts: any;
  setAddPatriotAlertDialogOpen: any;
  softguardAlerts: any;
  setAddSoftguardAlertDialogOpen: any;
  immixAlertsOnCamera?: boolean;
  diceAlertsOnCamera?: boolean;
  sureViewAlertsOnCamera: boolean;
  siteInfo: any;
  webhooksAlertsOnCamera: boolean;
  sentinelAlertsOnCamera: boolean;
  boldAlertsOnCamera: boolean;
  patriotAlertsOnCamera: boolean;
  softguardAlertsOnCamera: boolean;
  evalinkAlertsOnCamera: boolean;
  navigate: NavigateFunction;
}) => {
  const userInfo = JSON.parse(localStorage.userInfo);

  const patriotIgnoreZonesOnAlertPage = usePatriotIgnoreZonesOnAlertPage();

  const { userPermissions } = useAppStore();

  const permissions = userInfo.permission;

  const {
    setDeleteWebhookDialogOpen,
    setWebhookIdToDelete,
    webhooksData,
    cameraStreams,
    cameraStreamsSelectedIndex,
    cameraStreamsObject,
    setSelectedAlertId,
    setSelectedAlertType,
    setDeleteAlertDialogOpen,
    sysaidAlertsOnCamera,
    setAddSysaidAlertDialogOpen,
  } = useEditCameraStore();

  // State for password visibility
  const [showPasswords, setShowPasswords] = React.useState<{
    [key: string]: boolean;
  }>({});

  const handleClickShowPassword = (passwordId: string) => {
    setShowPasswords((prev) => ({
      ...prev,
      [passwordId]: !prev[passwordId],
    }));
  };

  const sureviewServerOptions = [
    ["US SMTP Server", "us-smtp.sureviewops.com"],
    ["EU SMTP Server", "eu-smtp.sureviewops.com"],
  ];
  const sureViewOptionNames = new Map();
  sureviewServerOptions.forEach((option: any) => {
    sureViewOptionNames.set(option[1], option[0]);
  });

  const webhooksTitlesArray = ["Webhook", "Custom Fields", "Event Type"];

  const handleConvertTypeToString = (string: any) => {
    if (string === "no_motion") {
      return "No Motion";
    } else if (string === "unable_to_connect") {
      return "Unable to Connect";
    } else if (string === "detection") {
      return "Detection";
    } else return "";
  };

  return (
    <div className="relative w-full min-w-[1150px]">
      {cameraStreams && cameraStreams.length > 1 && (
        <div className="bg-white">
          <SelectedStreamDropDown />
        </div>
      )}
      {immixAlertsOnCamera && (
        <div key="immixAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Immix Alerts
            </Typography>
            <div className="absolute right-[70px] top-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddImmixAlertDialogOpen(true);
                  }}
                  text="+ Add Immix Alert"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.immix_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[cameraStreamsSelectedIndex]?.immix_alerts?.map(
              (object: any, index: any) => {
                return (
                  <div key={object.id} className="h-[208px]">
                    <div className="min-w-[1150px] h-[80px] bg-white">
                      <div className="flex">
                        <Typography
                          gutterBottom
                          component="div"
                          sx={{
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "black",
                            textIndent: "1vw",
                            paddingTop: "10px",
                          }}
                        >
                          Immix Alert {index + 1}
                        </Typography>

                        <OrangeTextButton
                          onClick={() => {
                            setDeleteImmixAlertDialogOpen(true);
                            localStorage.setItem(
                              "selectedImmixAlertId",
                              object.id
                            );
                          }}
                          text={
                            <Tooltip
                              title={`Delete Immix Alert ${index + 1}`}
                              placement="top"
                              sx={{ fontSize: "20px", fontFamily: "mulish" }}
                            >
                              <DeleteIcon />
                            </Tooltip>
                          }
                          disabled={false}
                        />
                      </div>
                      <div className="pl-[10px]">
                        <OrangeTextButton
                          onClick={() => {
                            setSendingImmixTest(true);
                            handleSendImmixTest(
                              object,
                              setSendingImmixTest,
                              setImmixTestSuccessDialogOpen,
                              setImmixTestFailDialogOpen,
                              navigate
                            );
                          }}
                          text="Send test alert"
                          disabled={false}
                        />
                      </div>
                    </div>
                    <div>
                      <TableContainer component={Paper}>
                        <Table
                          sx={{ minWidth: 1000, fontFamily: "Mulish" }}
                          aria-label="simple table"
                        >
                          <TableHeadComponent
                            titlesArray={[
                              "Immix Server",
                              "Immix Port",
                              "Immix Email",
                              "Immix input 1",
                              "Draw Ignore Zones",
                            ]}
                          />
                          <TableBody>
                            <TableRow key={object.id}>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.immix_server
                                  ? object.immix_server
                                  : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.immix_port ? object.immix_port : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.immix_email ? object.immix_email : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.immix_input1
                                  ? object.immix_input1
                                  : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.draw_ignore_zones !== null ? (
                                  <Switch
                                    color="warning"
                                    checked={object.draw_ignore_zones}
                                    disabled={true}
                                  />
                                ) : (
                                  "--"
                                )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                );
              }
            )}
        </div>
      )}
      {diceAlertsOnCamera && (
        <div key="diceAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Dice Alerts
            </Typography>
            <div className="absolute right-[70px] top-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddDiceAlertDialogOpen(true);
                  }}
                  text="+ Add Dice Alert"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.dice_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[cameraStreamsSelectedIndex]?.dice_alerts?.map(
              (object: any, index: any) => {
                return (
                  <div key={object.id} className="h-[208px]">
                    <div className="min-w-[1150px] h-[80px] bg-white">
                      <div className="flex">
                        <Typography
                          gutterBottom
                          component="div"
                          sx={{
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "black",
                            textIndent: "1vw",
                            paddingTop: "10px",
                          }}
                        >
                          Dice Alert {index + 1}
                        </Typography>

                        <OrangeTextButton
                          onClick={() => {
                            setDeleteDiceAlertDialogOpen(true);
                            localStorage.setItem(
                              "selectedDiceAlertId",
                              object.id
                            );
                          }}
                          text={
                            <Tooltip
                              title={`Delete Dice Alert ${index + 1}`}
                              placement="top"
                              sx={{ fontSize: "20px", fontFamily: "mulish" }}
                            >
                              <DeleteIcon />
                            </Tooltip>
                          }
                          disabled={false}
                        />
                      </div>
                      <div className="pl-[10px]">
                        <OrangeTextButton
                          onClick={() => {
                            setSendingDiceTest(true);
                            handleSendDiceTest(
                              object,
                              setSendingDiceTest,
                              setDiceTestSuccessDialogOpen,
                              setDiceTestFailDialogOpen,
                              navigate
                            );
                          }}
                          text="Send test alert"
                          disabled={false}
                        />
                      </div>
                    </div>
                    <div>
                      <TableContainer component={Paper}>
                        <Table
                          sx={{ minWidth: 1000, fontFamily: "Mulish" }}
                          aria-label="simple table"
                        >
                          <TableHeadComponent
                            titlesArray={[
                              "Dice Server",
                              "Dice Port",
                              "Dice Email",
                              "Dice input 1",
                              "Draw Ignore Zones",
                            ]}
                          />
                          <TableBody>
                            <TableRow key={object.id}>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.dice_server ? object.dice_server : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.dice_port ? object.dice_port : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.dice_email ? object.dice_email : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.dice_input1 ? object.dice_input1 : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.draw_ignore_zones !== null ? (
                                  <Switch
                                    color="warning"
                                    checked={object.draw_ignore_zones}
                                    disabled={true}
                                  />
                                ) : (
                                  "--"
                                )}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                );
              }
            )}
        </div>
      )}
      {sureViewAlertsOnCamera && (
        <div key="sureviewAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white flex relative">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Sureview Alerts
            </Typography>
            <div className="absolute right-[70px] pt-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddSureviewAlertDialogOpen(true);
                  }}
                  text="+ Add Sureview Alert"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.sureview_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[
              cameraStreamsSelectedIndex
            ]?.sureview_alerts?.map((object: any, index: any) => {
              return (
                <div key={object.id} className="h-[148px]">
                  <div className="min-w-[1150px] h-[40px] bg-white">
                    <div className="flex">
                      <Typography
                        gutterBottom
                        component="div"
                        sx={{
                          fontFamily: "Mulish",
                          fontWeight: "Bold",
                          color: "black",
                          textIndent: "1vw",
                          paddingTop: "10px",
                        }}
                      >
                        Sureview Alert {index + 1}
                      </Typography>
                      <OrangeTextButton
                        onClick={() => {
                          setSelectedAlertId(object.id);
                          setSelectedAlertType("sureview");
                          setDeleteAlertDialogOpen(true);
                        }}
                        text={
                          <Tooltip
                            title={`Delete Sureview Alert ${index + 1}`}
                            placement="top"
                            sx={{ fontSize: "20px", fontFamily: "mulish" }}
                          >
                            <DeleteIcon />
                          </Tooltip>
                        }
                        disabled={false}
                      />
                    </div>
                  </div>
                  <div>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 1000, fontFamily: "Mulish" }}
                        aria-label="simple table"
                      >
                        <TableHeadComponent
                          titlesArray={[
                            "Sureview Server",
                            "Sureview Subject",
                            "Sureview cc",
                            "Sureview Email",
                          ]}
                        />
                        <TableBody>
                          <TableRow key={object.id}>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.sureview_server
                                ? sureViewOptionNames.get(
                                    object.sureview_server
                                  )
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.sureview_subject
                                ? object.sureview_subject
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.sureview_cc ? object.sureview_cc : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.sureview_email
                                ? object.sureview_email
                                : "--"}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {(webhooksData || siteInfo.webhooks || webhooksAlertsOnCamera) && (
        <div key="webhooks" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white flex relative">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Webhooks
            </Typography>
            <div className="absolute right-[70px] pt-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddStreamWebhookDialogOpen(true);
                  }}
                  text="+ Add Stream Webhook"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {webhooksData &&
            webhooksData[0] &&
            webhooksData
              .filter(
                (object: any) =>
                  cameraStreams &&
                  cameraStreams[cameraStreamsSelectedIndex] &&
                  object.stream.id ===
                    cameraStreams[cameraStreamsSelectedIndex].id
              )
              .map((object: any, index: any) => {
                return (
                  <div key={object.id} className="h-[168px]">
                    <div className="min-w-[1150px] h-[60px] bg-white">
                      <Typography
                        gutterBottom
                        component="div"
                        sx={{
                          fontFamily: "Mulish",
                          fontWeight: "Bold",
                          color: "black",
                          textIndent: "1vw",
                          paddingTop: "10px",
                        }}
                      >
                        Stream Webhook {index + 1}
                        <OrangeTextButton
                          onClick={() => {
                            localStorage.setItem(
                              "selectedWebhook",
                              JSON.stringify(object)
                            );
                            setEditStreamWebhookDialogOpen(true);
                          }}
                          text={
                            <>
                              <EditIcon fontSize="small" />
                            </>
                          }
                          disabled={false}
                        />
                        <OrangeTextButton
                          onClick={() => {
                            setDeleteWebhookDialogOpen(true);
                            setWebhookIdToDelete(object.id);
                          }}
                          text={
                            <>
                              <DeleteIcon fontSize="small" />
                            </>
                          }
                          disabled={false}
                        />
                      </Typography>
                    </div>
                    <div>
                      <TableContainer component={Paper} sx={{ width: "100%" }}>
                        <Table
                          sx={{
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed",
                          }}
                        >
                          <TableHeadComponent
                            titlesArray={webhooksTitlesArray}
                          />
                          <TableBody>
                            <TableRow>
                              <TableCell
                                align="left"
                                sx={{
                                  fontFamily: "Mulish",
                                  width: "33.33%",
                                  wordWrap: "break-word",
                                }}
                              >
                                {object.webhook.display_name
                                  ? object.webhook.display_name
                                  : ""}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  fontFamily: "Mulish",
                                  width: "33.33%",
                                  wordWrap: "break-word",
                                }}
                              >
                                {object.custom_fields
                                  ? `${JSON.stringify(object.custom_fields)}`
                                  : ""}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{
                                  fontFamily: "Mulish",
                                  width: "33.33%",
                                  wordWrap: "break-word",
                                }}
                              >
                                {object.event_types
                                  ? object.event_types[0]
                                    ? //map object.event_types and return each one using handleConvertTypeToString separated by a comma
                                      object.event_types.map(
                                        (
                                          eventType: any,
                                          eventIndex: number
                                        ) => {
                                          const isLast =
                                            eventIndex ===
                                            object.event_types.length - 1;
                                          return `${handleConvertTypeToString(
                                            eventType
                                          )}${isLast ? "" : ", "}`;
                                        }
                                      )
                                    : ""
                                  : ""}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                );
              })}
        </div>
      )}
      {sentinelAlertsOnCamera && (
        <div key="sentinelAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white flex relative">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Sentinel Alerts
            </Typography>
            <div className="absolute right-[70px] pt-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddSentinelAlertDialogOpen(true);
                  }}
                  text="+ Add Sentinel Alert"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.sentinel_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[
              cameraStreamsSelectedIndex
            ]?.sentinel_alerts?.map((object: any, index: any) => {
              return (
                <div key={object.id} className="h-[168px]">
                  <div className="min-w-[1150px] h-[40px] bg-white">
                    <div className="flex">
                      <Typography
                        gutterBottom
                        component="div"
                        sx={{
                          fontFamily: "Mulish",
                          fontWeight: "Bold",
                          color: "black",
                          textIndent: "1vw",
                          paddingTop: "10px",
                        }}
                      >
                        Sentinel Alert {index + 1}
                      </Typography>
                      <OrangeTextButton
                        onClick={() => {
                          setSelectedAlertId(object.id);
                          setSelectedAlertType("sentinel");
                          setDeleteAlertDialogOpen(true);
                        }}
                        text={
                          <Tooltip
                            title={`Delete Sentinel Alert ${index + 1}`}
                            placement="top"
                            sx={{ fontSize: "20px", fontFamily: "mulish" }}
                          >
                            <DeleteIcon />
                          </Tooltip>
                        }
                        disabled={false}
                      />
                    </div>
                  </div>
                  <div>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 1000, fontFamily: "Mulish" }}
                        aria-label="simple table"
                      >
                        <TableHeadComponent
                          titlesArray={[
                            "Sentinel Server",
                            "Sentinel Site Id",
                            "Sentinel Device Address",
                            "Draw Ignore Zones",
                          ]}
                        />
                        <TableBody>
                          <TableRow key={object.id}>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.sentinel_server
                                ? object.sentinel_server
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.sentinel_site_id
                                ? object.sentinel_site_id
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.sentinel_device_address
                                ? object.sentinel_device_address
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.draw_ignore_zones !== null ? (
                                <Switch
                                  color="warning"
                                  checked={object.draw_ignore_zones}
                                  disabled={true}
                                />
                              ) : (
                                "--"
                              )}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {boldAlertsOnCamera && (
        <div key="boldAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white flex relative">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Bold Alerts
            </Typography>
            <div className="absolute right-[70px] pt-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddBoldAlertDialogOpen(true);
                  }}
                  text="+ Add Bold Alert"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.bold_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[cameraStreamsSelectedIndex]?.bold_alerts?.map(
              (object: any, index: any) => {
                return (
                  <div key={object.id} className="h-[160px]">
                    <div className="min-w-[1150px] h-[50px] pt-[10px] bg-white">
                      <div className="flex">
                        <Typography
                          gutterBottom
                          component="div"
                          sx={{
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "black",
                            textIndent: "1vw",
                          }}
                        >
                          Bold Alert {index + 1}
                        </Typography>
                        <OrangeTextButton
                          onClick={() => {
                            setSelectedAlertId(object.id);
                            setSelectedAlertType("bold");
                            setDeleteAlertDialogOpen(true);
                          }}
                          text={
                            <Tooltip
                              title={`Delete Bold Alert ${index + 1}`}
                              placement="top"
                              sx={{ fontSize: "20px", fontFamily: "mulish" }}
                            >
                              <DeleteIcon />
                            </Tooltip>
                          }
                          disabled={false}
                        />
                      </div>
                    </div>
                    <div>
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 1000, fontFamily: "Mulish" }}>
                          <TableHeadComponent
                            titlesArray={[
                              "Bold Server",
                              "Bold port",
                              "Bold id",
                              "Bold sdnis",
                              "Bold Zone",
                              "Bold Alarm Type",
                            ]}
                          />
                          <TableBody>
                            <TableRow key={object.id}>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.bold_server ? object.bold_server : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.bold_port ? object.bold_port : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.bold_id ? object.bold_id : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.bold_sdnis ? object.bold_sdnis : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.bold_zone ? object.bold_zone : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.bold_alarmtype
                                  ? object.bold_alarmtype
                                  : "--"}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                );
              }
            )}
        </div>
      )}
      {patriotAlertsOnCamera && (
        <div key="patriotAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white flex relative">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Patriot Alerts
            </Typography>
            <div className="absolute right-[70px] pt-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddPatriotAlertDialogOpen(true);
                  }}
                  text="+ Add Patriot Alert"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.patriot_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[
              cameraStreamsSelectedIndex
            ]?.patriot_alerts?.map((object: any, index: any) => {
              return (
                <div key={object.id} className="min-h-[160px]">
                  <div className="min-w-[1150px] h-[50px] pt-[10px] bg-white">
                    <div className="flex">
                      <Typography
                        gutterBottom
                        component="div"
                        sx={{
                          fontFamily: "Mulish",
                          fontWeight: "Bold",
                          color: "black",
                          textIndent: "1vw",
                        }}
                      >
                        Patriot Alert {index + 1}
                      </Typography>
                      <OrangeTextButton
                        onClick={() => {
                          setSelectedAlertId(object.id);
                          setSelectedAlertType("patriot");
                          setDeleteAlertDialogOpen(true);
                        }}
                        text={
                          <Tooltip
                            title={`Delete Patriot Alert ${index + 1}`}
                            placement="top"
                            sx={{ fontSize: "20px", fontFamily: "mulish" }}
                          >
                            <DeleteIcon />
                          </Tooltip>
                        }
                        disabled={false}
                      />
                    </div>
                  </div>
                  <div>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 1000, fontFamily: "Mulish" }}>
                        <TableHeadComponent
                          titlesArray={[
                            "Patriot Server",
                            "Patriot client no",
                            "Patriot username",
                            "Patriot password",
                            "Patriot zone number",
                            "Patriot type number",
                            PATRIOT_DELIVERY_LABEL,
                          ]}
                        />
                        <TableBody>
                          <TableRow key={object.id}>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.patriot_server
                                ? object.patriot_server
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.patriot_client_no
                                ? object.patriot_client_no
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.patriot_username
                                ? object.patriot_username
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.patriot_password ? (
                                userPermissions.view_passwords ? (
                                  <div className="flex">
                                    {showPasswords[object.id]
                                      ? object.patriot_password
                                      : createDots(object.patriot_password)}
                                    <div>
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label={
                                            showPasswords[object.id]
                                              ? "hide the password"
                                              : "display the password"
                                          }
                                          onClick={() =>
                                            handleClickShowPassword(object.id)
                                          }
                                          onMouseDown={(event) =>
                                            event.preventDefault()
                                          }
                                          onMouseUp={(event) =>
                                            event.preventDefault()
                                          }
                                          edge="end"
                                        >
                                          {showPasswords[object.id] ? (
                                            <VisibilityOff />
                                          ) : (
                                            <Visibility />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flex items-center">
                                    {createDots(object.patriot_password)}
                                  </div>
                                )
                              ) : (
                                "--"
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.patriot_zone_number
                                ? object.patriot_zone_number
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.patriot_type_number
                                ? object.patriot_type_number
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                              data-testid="patriot-delivery-display"
                            >
                              {patriotDeliveryDisplayText(
                                object.patriot_send_video,
                                object.draw_ignore_zones,
                                patriotIgnoreZonesOnAlertPage
                              )}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <PatriotDeliverySummary
                      sendVideo={object.patriot_send_video}
                      drawIgnoreZones={object.draw_ignore_zones}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {softguardAlertsOnCamera && (
        <div key="softguardAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white flex relative">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Softguard Alerts
            </Typography>
            <div className="absolute right-[70px] pt-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddSoftguardAlertDialogOpen(true);
                  }}
                  text="+ Add Softguard Alert"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.softguard_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[
              cameraStreamsSelectedIndex
            ]?.softguard_alerts?.map((object: any, index: any) => {
              return (
                <div key={object.id} className="h-[160px]">
                  <div className="min-w-[1150px] h-[50px] pt-[10px] bg-white">
                    <div className="flex">
                      <Typography
                        gutterBottom
                        component="div"
                        sx={{
                          fontFamily: "Mulish",
                          fontWeight: "Bold",
                          color: "black",
                          textIndent: "1vw",
                        }}
                      >
                        Softguard Alert {index + 1}
                      </Typography>
                      <OrangeTextButton
                        onClick={() => {
                          setSelectedAlertId(object.id);
                          setSelectedAlertType("softguard");
                          setDeleteAlertDialogOpen(true);
                        }}
                        text={
                          <Tooltip
                            title={`Delete Softguard Alert ${index + 1}`}
                            placement="top"
                            sx={{ fontSize: "20px", fontFamily: "mulish" }}
                          >
                            <DeleteIcon />
                          </Tooltip>
                        }
                        disabled={false}
                      />
                    </div>
                  </div>
                  <div>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 1000, fontFamily: "Mulish" }}>
                        <TableHeadComponent
                          titlesArray={[
                            "Server",
                            "Port",
                            "Zone",
                            "Account",
                            "User",
                            "User Ext",
                          ]}
                        />
                        <TableBody>
                          <TableRow key={object.id}>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.server ? object.server : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.port ? object.port : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.zone ? object.zone : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.account ? object.account : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.user ? object.user : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.user_ext ? object.user_ext : "--"}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {evalinkAlertsOnCamera && (
        <div key="evalinkAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white flex relative">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Evalink Alerts
            </Typography>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.evalink_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[
              cameraStreamsSelectedIndex
            ]?.evalink_alerts?.map((object: any, index: any) => {
              return (
                <div key={object.id} className="h-[148px]">
                  <div className="min-w-[1150px] h-[40px] bg-white">
                    <Typography
                      gutterBottom
                      component="div"
                      sx={{
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        color: "black",
                        textIndent: "1vw",
                        paddingTop: "10px",
                      }}
                    >
                      Evalink Alert {index + 1}
                    </Typography>
                  </div>
                  <div>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 1000, fontFamily: "Mulish" }}
                        aria-label="simple table"
                      >
                        <TableHeadComponent
                          titlesArray={[
                            "Evalink Token",
                            "Evalink Device ID",
                            "Evalink Company ID",
                            "Partition ID",
                            "Alarm Zone ID",
                          ]}
                        />
                        <TableBody>
                          <TableRow key={object.id}>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.evalink_token
                                ? object.evalink_token
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.evalink_device_id
                                ? object.evalink_device_id
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.evalink_company_id
                                ? object.evalink_company_id
                                : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.partition_id ? object.partition_id : "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ fontFamily: "Mulish" }}
                            >
                              {object.alarm_zone_id
                                ? object.alarm_zone_id
                                : "--"}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {sysaidAlertsOnCamera && (
        <div key="sysaidAlerts" className="pb-[20px]">
          <div className="min-w-[1150px] h-[60px] bg-white flex relative">
            <Typography
              variant="h6"
              gutterBottom
              component="div"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "black",
                textIndent: "1vw",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              SysAid Alerts
            </Typography>
            <div className="absolute right-[70px] pt-[10px]">
              {permissions.edit_cameras && (
                <OrangeTextButton
                  onClick={() => {
                    setAddSysaidAlertDialogOpen(true);
                  }}
                  text="+ Add SysAid Alert"
                  disabled={false}
                />
              )}
            </div>
          </div>
          {cameraStreamsObject &&
            cameraStreamsObject[cameraStreamsSelectedIndex] &&
            (cameraStreamsObject[cameraStreamsSelectedIndex]?.sysaid_alerts
              ?.length ?? 0) > 0 &&
            cameraStreamsObject[cameraStreamsSelectedIndex]?.sysaid_alerts?.map(
              (object: any, index: any) => {
                return (
                  <div key={object.id} className="h-[160px]">
                    <div className="min-w-[1150px] h-[50px] pt-[10px] bg-white">
                      <div className="flex">
                        <Typography
                          gutterBottom
                          component="div"
                          sx={{
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "black",
                            textIndent: "1vw",
                          }}
                        >
                          SysAid Alert {index + 1}
                        </Typography>
                        <OrangeTextButton
                          onClick={() => {
                            setSelectedAlertId(object.id);
                            setSelectedAlertType("sysaid");
                            setDeleteAlertDialogOpen(true);
                          }}
                          text={
                            <Tooltip
                              title={`Delete SysAid Alert ${index + 1}`}
                              placement="top"
                              sx={{ fontSize: "20px", fontFamily: "mulish" }}
                            >
                              <DeleteIcon />
                            </Tooltip>
                          }
                          disabled={false}
                        />
                      </div>
                    </div>
                    <div>
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 1000, fontFamily: "Mulish" }}>
                          <TableHeadComponent
                            titlesArray={[
                              "SysAid server",
                              "SysAid client local",
                              "SysAid username",
                              "SysAid password",
                            ]}
                          />
                          <TableBody>
                            <TableRow key={object.id}>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.sysaid_server
                                  ? object.sysaid_server
                                  : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.sysaid_client_local
                                  ? object.sysaid_client_local
                                  : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.sysaid_username
                                  ? object.sysaid_username
                                  : "--"}
                              </TableCell>
                              <TableCell
                                align="left"
                                sx={{ fontFamily: "Mulish" }}
                              >
                                {object.sysaid_password
                                  ? object.sysaid_password
                                  : "--"}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                );
              }
            )}
        </div>
      )}
    </div>
  );
};
